import { BehaviorSubject } from 'rxjs';

export class StaticMemory {
  public static xRoute = '&T(%^&IYU6756856iyku,gKYUGL>IUH' + window.location.hostname;

  private static _isAuthVerified$ = new BehaviorSubject<boolean>(false);
  private static _isServiceArea$ = new BehaviorSubject<boolean>(false);
  private static _addressObject$ = new BehaviorSubject<any>({});
  private static _serAreaObject$ = new BehaviorSubject<any>({});
  private static _businessProfileObject$ = new BehaviorSubject<any>({});
  private static _walletBalance$ = new BehaviorSubject<number>(0);
  private static _menuHidden$ = new BehaviorSubject<boolean>(false);
  private static _profileDetails$ = new BehaviorSubject<any>({});

  public static readonly isAuthVerified$ = StaticMemory._isAuthVerified$.asObservable();
  public static readonly isServiceArea$ = StaticMemory._isServiceArea$.asObservable();
  public static readonly addressObject$ = StaticMemory._addressObject$.asObservable();
  public static readonly serAreaObject$ = StaticMemory._serAreaObject$.asObservable();
  public static readonly businessProfileObject$ = StaticMemory._businessProfileObject$.asObservable();
  public static readonly walletBalance$ = StaticMemory._walletBalance$.asObservable();
  public static readonly menuHidden$ = StaticMemory._menuHidden$.asObservable();
  public static readonly profileDetails$ = StaticMemory._profileDetails$.asObservable();

  public static get isAuthVerified(): boolean {
    return StaticMemory._isAuthVerified$.value;
  }
  public static set isAuthVerified(val: boolean) {
    StaticMemory._isAuthVerified$.next(val);
  }

  public static get isServiceArea(): boolean {
    return StaticMemory._isServiceArea$.value;
  }
  public static set isServiceArea(val: boolean) {
    StaticMemory._isServiceArea$.next(val);
  }

  public static get addressObject(): any {
    return StaticMemory._addressObject$.value;
  }
  public static set addressObject(val: any) {
    StaticMemory._addressObject$.next(val);
  }

  public static get serAreaObject(): any {
    return StaticMemory._serAreaObject$.value;
  }
  public static set serAreaObject(val: any) {
    StaticMemory._serAreaObject$.next(val);
  }

  public static get businessProfileObject(): any {
    return StaticMemory._businessProfileObject$.value;
  }
  public static set businessProfileObject(val: any) {
    StaticMemory._businessProfileObject$.next(val);
  }

  public static get walletBalance(): number {
    return StaticMemory._walletBalance$.value;
  }
  public static set walletBalance(val: number) {
    StaticMemory._walletBalance$.next(val);
  }

  public static get menuHidden(): boolean {
    return StaticMemory._menuHidden$.value;
  }
  public static set menuHidden(val: boolean) {
    StaticMemory._menuHidden$.next(val);
  }

  public static get profileDetails(): any {
    return StaticMemory._profileDetails$.value;
  }
  public static set profileDetails(val: any) {
    StaticMemory._profileDetails$.next(val);
  }

  public static onCashBackOfferCalculation(data: any, gTotal: number) {
    let currentOffer: any = null;
    let nextOffer: any = null;
    if (data && Array.isArray(data)) {
      data.forEach((offer: any) => {
        if (offer.invoiceValue <= gTotal) {
          if (!currentOffer || offer.invoiceValue > currentOffer.invoiceValue) {
            currentOffer = offer;
          }
        } else if (!nextOffer || offer.invoiceValue < nextOffer.invoiceValue) {
          nextOffer = offer;
        }
      });
    }
    const remaining = nextOffer ? nextOffer.invoiceValue - gTotal : null;
    return {
      currentOffer,
      nextOffer,
      remaining: remaining && remaining > 0 ? remaining : null,
    };
  }
}
